/* React */
import React from "react";

/* Components */
import Searchbar from "src/components/shared/searchbar/Searchbar";
import TreatmentLineFilter from "src/components/chart-wrapper/toolbar/options/horizontal-boxplot-options/treatment-line-filter/TreatmentLineFilter";
import InfoIconWrapper from "src/utils/wrapper/info-icon-wrapper/InfoIconWrapper";
import ContentContainer from "src/components/chart-wrapper/toolbar/options/horizontal-boxplot-options/content-container/ContentContainer";

/* Stylesheet */
import styles from "./HorizontalBoxplotOptions.module.scss";

/* Interfaces */
import { BoxplotProps } from "src/shared/interfaces/Boxplot";

interface HorizontalBoxplotOptionsProps {
  item: {
    name: string;
    data: BoxplotProps[];
  };
  selectedTLs: string[];
  handleSelectedTLs: (treatmentLines: string[]) => void;
  activeIndex?: number;
}

const HorizontalBoxplotOptions: React.FC<
  HorizontalBoxplotOptionsProps
> = ({
  item,
  selectedTLs,
  handleSelectedTLs,
  activeIndex,
}) => {
  return (
    <div className={styles.horizontal_boxplot_options}>
      <InfoIconWrapper>
        <ContentContainer name={item.name} />
      </InfoIconWrapper>
      <Searchbar disabled={true} />
      <TreatmentLineFilter
        data={item.data}
        selectedTLs={selectedTLs}
        handleSelectedTLs={handleSelectedTLs}
        activeIndex={activeIndex}
      />
    </div>
  );
};

export default HorizontalBoxplotOptions;
